import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';


const RollUpDoor = ({ width, height, trimWidth, isOverlap,doorColor, overlapTrimColor}) => {
    const trimColor = useMemo(() => {

            return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    

    
    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();
        
        return model;
    }, [width, height, trimWidth])

    const doorSideModel = useMemo(() => {
        const initPatternSize = 0.3;
        const initPatternCount = Math.floor(height / initPatternSize);
        let patternCount = initPatternCount;
        if (height - initPatternSize * initPatternCount >= initPatternSize / 2) patternCount += 1;
        const patternSize = height / patternCount;
        const unitPatternSize = patternSize / 6;

        const model = new THREE.Shape();
        model.moveTo(0, 0);
        let initPos = 0
        new Array(patternCount - 1).fill("").map((_, index) => {
            initPos = patternSize * index;
            model.lineTo(0, initPos + 0);
            model.lineTo(0, initPos + unitPatternSize * 1);
            model.lineTo(unitPatternSize * 1.5, initPos + unitPatternSize * 2);
            model.lineTo(unitPatternSize * 1.5, initPos + unitPatternSize * 4);
            model.lineTo(0, initPos + unitPatternSize * 5);
            model.lineTo(0, initPos + unitPatternSize * 6);
        })
        model.lineTo(-0.005, initPos + patternSize);
        model.lineTo(-0.005, 0);
        model.closePath();

        return model
    }, [width, height])

    const bottomMetalPartModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2 + trimWidth,  -height / 2 + 0.3);
        model.lineTo(width / 2 - trimWidth,  -height / 2 + 0.3);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.closePath();

        return model;
    }, [width, height, trimWidth])
    return (
        <>
            <mesh name='trim' renderOrder={1}>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh position={[-(-width / 2 + trimWidth), -height / 2 + 0.25, 0.05]} rotation={[0, -Math.PI / 2, 0]} renderOrder={1}>
                <extrudeGeometry args={[doorSideModel, extrudeSettings(width - trimWidth * 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                {/* <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} /> */}

            </mesh>
            <mesh position={[(-width / 2 + trimWidth), -height / 2 + 0.25, 0.06]} rotation={[0, Math.PI / 2, 0]} renderOrder={1}>
                <extrudeGeometry args={[doorSideModel, extrudeSettings(width - trimWidth * 2)]} />
                {/* <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.4} metalness={0.3} emissive={'#160C02'} /> */}
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />

            </mesh>
            {/* <mesh name='door' position={[0, 0, 0.025]} castShadow receiveShadow>
                <planeGeometry args={[width, height, 10, height*25]} />
                <meshStandardMaterial displacementMap={texture} map={shaderTexture} bumpMap={texture} bumpScale={1} displacementScale={0.07} color={doorColor} side={THREE.DoubleSide} metalness={0.4} roughness={0.6} emissive={"gray"} />
            </mesh> */}
            <mesh name='bottom' position={[0, 0, 0.025]} renderOrder={1}>
                <extrudeGeometry args={[bottomMetalPartModel, extrudeSettings(0.05)]} />
                <meshStandardMaterial color={doorColor} side={THREE.DoubleSide} metalness={0.6} roughness={0.2} />
            </mesh>
        </>
    )
}

export default RollUpDoor